import React from 'react';
import {Divider, ListItem} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {useSelector} from "react-redux";
import {getRoomTotal} from "../../../utils/utils";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    section2: {
        margin: theme.spacing(1, 0),
    },
}));

const RoomSummary = ({room}) => {
    const {selectedRooms} = useSelector(state => state.transactions);

    const roomTypeSelection = selectedRooms.filter(s => s.index === room.index);
    const hasSingle = roomTypeSelection.some(s => s.singleOccupancy);
    const roomTotal = getRoomTotal(room, roomTypeSelection);

    const classes = useStyles();

    return (
        <>
            <ListItem className={classes.section2}>
                <Grid container alignItems="center">
                    <Grid item xs>
                        <Typography gutterBottom variant="h5" align="left">
                            {/<\/?[a-z][\s\S]*>/i.test(room['title']) ?<span dangerouslySetInnerHTML={{__html: room['title']}}/>:room['title']} {hasSingle && roomTypeSelection.length>1? roomTypeSelection.length - 1 : roomTypeSelection.length>1 ? 'x' + (hasSingle ? roomTypeSelection.length - 1 : roomTypeSelection.length) : ''}
                        </Typography>
                        {hasSingle && roomTypeSelection.length===1 &&
                        <Typography color="textSecondary" variant="body2">
                            Single Occupancy
                        </Typography>
                        }
                    </Grid>
                    <Grid item xs>
                        <Typography variant="h5" component="h5" align="right">
                            ${roomTotal.formatMoney(2)}
                        </Typography>
                    </Grid>
                </Grid>
            </ListItem>
            <Divider variant="middle" className={'dividerFullWidth'}/>
            {hasSingle && roomTypeSelection.length>1 && <>
                <ListItem className={classes.section2}>
                    <Grid container alignItems="center">
                        <Grid item xs>
                            <Typography gutterBottom variant="h5" align="left">
                                {/<\/?[a-z][\s\S]*>/i.test(room['title']) ?<span dangerouslySetInnerHTML={{__html: room['title']}}/>:room['title']}
                            </Typography>
                            <Typography color="textSecondary" variant="body2">
                                Single Occupancy
                            </Typography>
                        </Grid>
                        <Grid item xs>
                            <Typography variant="h5" component="h5" align="right">
                                ${roomTotal.formatMoney(2)}
                            </Typography>
                        </Grid>
                    </Grid>
                </ListItem>
                <Divider variant="middle" className={'dividerFullWidth'}/>
            </>
            }
        </>
    );
};

export default RoomSummary;
